import React, { useContext, useEffect, useState } from "react";
import { IoIosAddCircleOutline } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import AlertContext from "../../../../Context/Alert/AlertContext";
import { BaseURL } from "../../../../Files/BaseURL";
import { FaFileAlt, FaTimes } from "react-icons/fa";
import ThemeContext from "../../../../Context/theme/ThemeContext";

const Step1 = () => {
  const { theme } = useContext(ThemeContext);
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [industries, setIndustries] = useState([]);
  const [styles, setStyles] = useState([]);

  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedIndustry, setSelectedIndustry] = useState("");
  const [selectedStyle, setSelectedStyle] = useState("");

  const [files, setFiles] = useState([]);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [amount, setAmount] = useState("");
  const [flexible, setFlexible] = useState(false);
  const [deliveryDate, setDeliveryDate] = useState("");

  const alertcontext = useContext(AlertContext);
  const { showAlert } = alertcontext;
  const [loading, setLoading] = useState(false);

  const fetchCategories = async () => {
    try {
      const response = await fetch(`${BaseURL}/api/requestjob/getcategory`);
      const data = await response.json();
      setCategories(data);
    } catch (error) {
      showAlert("Error fetching categories", "danger");
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchIndustries = async () => {
    try {
      const response = await fetch(
        `${BaseURL}/api/requestjob/getIndustry/${selectedCategory}`
      );
      const data = await response.json();
      setIndustries(data);
    } catch (error) {
      showAlert("Error fetching Industries", "danger");
    }
  };

  useEffect(() => {
    if (selectedCategory) {
      fetchIndustries();
    }
  }, [selectedCategory]);

  const fetchStyles = async () => {
    try {
      if (selectedCategory && selectedIndustry) {
        const response = await fetch(
          `${BaseURL}/api/requestjob/getStyles/${selectedCategory}/${selectedIndustry}`
        );
        const data = await response.json();
        setStyles(data);
      }
    } catch (error) {
      showAlert("Error fetching Styles", "danger");
    }
  };

  useEffect(() => {
    if (selectedCategory && selectedIndustry) {
      fetchStyles();
    }
  }, [selectedCategory, selectedIndustry]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFiles((prevFiles) => [...prevFiles, file]);
  };

  const removeFile = (index) => {
    setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  const validateForm = () => {
    if (
      !title ||
      !selectedCategory ||
      !selectedIndustry ||
      !selectedStyle ||
      !description
    ) {
      showAlert("Please fill in all required fields.", "danger");
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      return;
    }

    // const formData = new FormData();
    // formData.append("Title", title);
    // formData.append("Category", selectedCategory);
    // formData.append("Industry", selectedIndustry);
    // formData.append("Styles", selectedStyle);
    // formData.append("Description", description);
    // formData.append("amount", amount);
    // formData.append("flexible", flexible);
    // formData.append("DeliveryDate", deliveryDate);
    //
    // files.forEach((file) => {
    //   formData.append("Attachfile", file);
    //   formData.append("OrignalNames", file.name);
    // });
    setLoading(true);

    // try {
    //   const authToken = localStorage.getItem("p@token");
    //   const response = await fetch(`${BaseURL}/api/requestjob/uploadData`, {
    //     method: "POST",
    //     headers: {
    //       "auth-token": authToken,
    //     },
    //     body: formData,
    //   });
    //
    //   if (response.ok) {
    //     const data = await response.json();
    //     const jobId = data._id;
    navigate(`/user-dashboard/create_request/request-pricing`, {
      state: {
        title,
        selectedCategory,
        selectedIndustry,
        selectedStyle,
        description,
        files,
      },
    });
    //   } else {
    //     showAlert("Failed to create job. Please try again.", "danger");
    //     setLoading(false);
    //   }
    // } catch (error) {
    //   console.error("Network Error:", error);
    //   showAlert("Network error. Please try again.", "danger");
    //   setLoading(false);
    // }
  };

  return (
    <div className="flex items-center font-pop flex-col">
      <div
        className={`  rounded-2xl py-6 px-6 my-6 w-[95%] md:w-[70%] xl:w-[40%] flex flex-col gap-4 *
      ${theme === "dark" ? "bg-black text-white" : "bg-white"}`}
      >
        Request a Job
        <div className="flex flex-col gap-4">
          <input
            type="text"
            id="price"
            name="price"
            required
            placeholder="Give your project brief a title"
            className={`w-full px-6 border-2 border-transparent font-pop text-base rounded-full bg-[#E8E8E8] py-2 focus:border-primarygreen focus:outline-none
            ${
              theme === "dark"
                ? "bg-black text-white border  border-white"
                : "bg-white"
            }`}
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
          <select
            name="category"
            id="category"
            required
            onChange={(e) => setSelectedCategory(e.target.value)}
            value={selectedCategory}
            className={`w-full px-6 border-2 border-transparent font-pop text-base rounded-full bg-[#E8E8E8] py-2 focus:border-primarygreen focus:outline-none
              ${
                theme === "dark"
                  ? "bg-black text-white border  border-white"
                  : "bg-white"
              }`}
          >
            <option value="" disabled>
              Select a Category
            </option>
            {categories.map((category) => (
              <option key={category._id} value={category.name}>
                {category.name}
              </option>
            ))}
          </select>

          <select
            name="industry"
            id="industry"
            required
            onChange={(e) => setSelectedIndustry(e.target.value)}
            value={selectedIndustry}
            className={`w-full px-6 border-2 border-transparent font-pop text-base rounded-full bg-[#E8E8E8] py-2 focus:border-primarygreen focus:outline-none
              ${
                theme === "dark"
                  ? "bg-black text-white border  border-white"
                  : "bg-white"
              }`}
          >
            <option value="" disabled>
              Which industry are you in?
            </option>
            {industries &&
              industries.map((industry) => (
                <option key={industry._id} value={industry.name}>
                  {industry.skill}
                </option>
              ))}
          </select>
          <select
            name="styles"
            id="styles"
            required
            onChange={(e) => setSelectedStyle(e.target.value)}
            value={selectedStyle}
            className={`w-full px-6 border-2 border-transparent font-pop text-base rounded-full bg-[#E8E8E8] py-2 focus:border-primarygreen focus:outline-none
              ${
                theme === "dark"
                  ? "bg-black text-white border  border-white"
                  : "bg-white"
              }`}
          >
            <option value="" disabled>
              Styles you're interested in
            </option>
            {styles.map((style) => (
              <option key={style._id} value={style.name}>
                {style.name}
              </option>
            ))}
          </select>

          <textarea
            name=""
            placeholder="What are you looking to get done?"
            id=""
            cols="30"
            required
            rows="4"
            className={`w-full px-6 border-2 border-transparent font-pop text-base rounded-2xl bg-[#E8E8E8] py-2 focus:border-primarygreen focus:outline-none ${
              theme === "dark"
                ? "bg-black text-white border  border-white"
                : "bg-white"
            }`}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          ></textarea>

          <div className="flex items-center justify-center w-full">
            <label
              htmlFor="dropzone-file"
              className={`flex flex-col items-center justify-center w-full border-2 border-primarygreen border-dashed rounded-lg cursor-pointer bg-transparent 
              ${
                theme === "dark"
                  ? "bg-black text-white border border-white"
                  : "bg-white"
              }`}
            >
              <div className="flex flex-row gap-4 items-center justify-center py-3 text-primarygreen font-pop">
                <IoIosAddCircleOutline className="text-2xl" />
                <p className={`text-base ${theme === "dark" && "text-white"}`}>
                  Attach file (Optional)
                </p>
              </div>
              <input
                id="dropzone-file"
                type="file"
                onChange={handleFileChange}
                className="hidden"
              />
            </label>
          </div>

          <div className="flex gap-2 flex-wrap">
            {files?.map((item, index) => (
              <div
                className="border-2 border-primarygreen w-fit overflow-hidden rounded-lg py-2 px-2 flex gap-1 items-center"
                key={index}
              >
                <FaFileAlt />
                <p>{item?.name}</p>
                <FaTimes onClick={() => removeFile(index)} />
              </div>
            ))}
          </div>

          <button
            className={`my-4 px-2 md:px-6 bg-green-500 hover:bg-transparent hover:bg-white-500 font-medium font-pop text-sm md:text-lg py-2 md:py-3 border border-black-500 hover:border-green-500 rounded-full text-white
            ${theme === "dark" ? "hover:text-white" : " hover:text-black"}`}
            onClick={handleSubmit}
          >
            {loading ? "Loading..." : "Next"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Step1;
